import React, { useState } from "react";
import { GenericDiv, Input, Label, PopupForm } from "../../../common/Style";

const Tables = ({ func, init }) => {
  const [data, setData] = useState("");
  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>מספר שולחן</Label>
        <Input
          type="number"
          min="0"
          onChange={(e) => setData(e.target.value)}
          placeholder="כתבו כאן..."
        />
        <GenericDiv
          onClick={() => func({ table: data }, init)}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שמירה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default Tables;
